import { Layout } from '../../../queries/ats/layout/types';
import { SectionItemEventProperties } from '../../interfaces/section-item-event';
import { TrackerEvent } from '../../interfaces/tracker-event';
import { LinkItemClickedEvent } from './link-item-clicked';
import { PageItemClickedEvent } from './page-item-clicked';
import { TitleItemClickedEvent } from './title-item-clicked';

export class ItemClickedEvent implements TrackerEvent<SectionItemEventProperties> {
  public name = 'item_clicked';
  public properties: SectionItemEventProperties;

  constructor(item: Layout.SectionItem, section: Layout.SectionView, page: Layout.PageView, pattern: Layout.Pattern) {
    let event: TrackerEvent<SectionItemEventProperties>;

    switch (item.type) {
      case 'page':
        event = new PageItemClickedEvent(item, section, page, pattern);
        break;
      case 'link':
        event = new LinkItemClickedEvent(item, section, page, pattern);
        break;
      case 'title':
        event = new TitleItemClickedEvent(item, section, page, pattern);
        break;
      default:
        throw new Error(`No event exists for section item with type "${item.type}"`);
    }

    this.properties = event.properties;
  }
}
